import { motion } from "framer-motion";
import { workProjects } from "@/data";
import { EASE } from "@/components/Reveal";

const Testimonial = ({ item, index }) => {
  const reversed = index % 2 === 1; // even index: image left; odd: image right

  const image = (
    <motion.div
      initial={{ opacity: 0, scale: 1.04 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.9, ease: EASE }}
      className={`lg:col-span-5 relative overflow-hidden aspect-square group ${
        reversed ? "order-1 lg:order-2" : "order-1"
      }`}
    >
      <img
        src={item.img}
        alt={item.title}
        loading="lazy"
        className="h-full w-full object-cover grayscale group-hover:grayscale-0 transition-all duration-700 group-hover:scale-105"
      />
      <span className="absolute top-5 left-5 font-head text-xs font-medium tracking-widest text-white/70">
        {item.n}
      </span>
    </motion.div>
  );

  const text = (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.8, ease: EASE, delay: 0.1 }}
      className={`lg:col-span-7 flex flex-col justify-center ${
        reversed ? "order-2 lg:order-1" : "order-2"
      }`}
    >
      <h3 className="font-head text-2xl sm:text-3xl lg:text-4xl font-medium uppercase kern-tight leading-none">
        {item.title}
      </h3>
      <p className="mt-6 text-sm sm:text-base leading-relaxed text-black/60 max-w-2xl">
        &ldquo;{item.quote}&rdquo;
      </p>
      <p className="mt-6 text-xs font-bold uppercase tracking-[0.22em] text-[var(--orange)]">
        {item.author}
      </p>
    </motion.div>
  );

  return (
    <div
      data-testid={`work-${index}`}
      className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 items-stretch"
    >
      {image}
      {text}
    </div>
  );
};

const Work = () => (
  <section
    id="work"
    data-testid="section-work"
    className="bg-white text-[var(--cerra-fg)] py-24 sm:py-32 px-5 sm:px-8"
  >
    <div className="mx-auto max-w-[1600px]">
      <div className="flex flex-col gap-4 mb-16 border-b border-[var(--cerra-border)] pb-8">
        <div>
          <span className="text-[var(--orange)] text-xs font-bold uppercase tracking-[0.22em]">
            ✦ In Their Words
          </span>
          <h2 className="mt-4 font-head text-3xl sm:text-4xl lg:text-5xl font-medium uppercase kern-tight leading-none">
            Testimonials
          </h2>
        </div>
        <p className="max-w-md text-sm text-black/60">
          Designed by Cerra. Considered from first sketch to final fabricated form.
        </p>
      </div>

      <div className="space-y-20 sm:space-y-28">
        {workProjects.map((item, i) => (
          <Testimonial key={item.title} item={item} index={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Work;
